import type { SVGProps } from 'react';
const uikitCrossTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg height={24} viewBox="0 0 24 24" width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M17.889 6.04129C17.5146 5.66638 16.9075 5.66638 16.5331 6.04129L11.9614 10.6186L7.38967 6.04129C7.01523 5.66638 6.40814 5.66638 6.03369 6.04129C5.65925 6.41619 5.65925 7.02403 6.03369 7.39893L10.6054 11.9763L5.98605 16.6013C5.61161 16.9762 5.61161 17.584 5.98605 17.9589C6.36049 18.3338 6.96758 18.3338 7.34203 17.9589L11.9614 13.3339L16.5807 17.9589C16.9552 18.3338 17.5622 18.3338 17.9367 17.9589C18.3111 17.584 18.3111 16.9762 17.9367 16.6013L13.3173 11.9763L17.889 7.39893C18.2635 7.02403 18.2635 6.41619 17.889 6.04129Z"
      fill={props.color ?? '#000'}
      fillRule="evenodd"
    />
  </svg>
);
export default uikitCrossTemplateOutline;
